module.exports = __webpack_public_path__ + "static/media/LOG9.5eff6e6a.png";